import { OverviewFilterParam } from "../types/overview";
import axios from "../utils/axiosClient";

export const fetchOverviewData = async (params: OverviewFilterParam) => {
  const response = await axios.get("/overview", { params });
  return response.data;
};

export const fetchTrendData = async (params: OverviewFilterParam) => {
  const response = await axios.get("/trends", { params });
  return response.data;
};

export const fetchEventFrequencyData = async (params: OverviewFilterParam) => {
  const response = await axios.get("/event-frequency", { params });
  return response.data;
};

export const fetchFilterOptions = async () => {
  const response = await axios.get("/filters");
  return response.data;
};

export const fetchFunnelData = async (endStep?: string, filters?: OverviewFilterParam) => {
  const params: any = {};
  if (endStep) params.end_step = endStep;
  if (filters) {
    Object.keys(filters).forEach((key) => {
      if (filters[key as keyof OverviewFilterParam] !== undefined) {
        params[key] = filters[key as keyof OverviewFilterParam];
      }
    });
  }
  const response = await axios.get("/funnel", { params });
  return response.data;
};

export const fetchCohortData = async (filters?: OverviewFilterParam) => {
  const params: any = {};
  if (filters) {
    Object.keys(filters).forEach((key) => {
      if (filters[key as keyof OverviewFilterParam] !== undefined) {
        params[key] = filters[key as keyof OverviewFilterParam];
      }
    });
  }
  const response = await axios.get("/cohort", { params });
  return response.data;
};
